<script>
export default {
  name: 'DialogTag',
  data(){
    return {
      showTagDialog:false,
      formTag: { tag_ids: [], artist_id: null, nickname: '' },
      tags:[]
    }
  },
  methods:{
    open(row){
      this.formTag.tag_ids = row.tag_ids || []
      this.formTag.artist_id = row.id || ''
      this.formTag.nickname = row.nickname || ''

      this.showTagDialog = true
    },
    async loadTagOptions() {
      await this.$api.getTagOptions().then((resp) => {
        this.tags = [...resp.list]
      })

    },
    handleTagChange(checked, tag_id, artist_id) {
      if (!artist_id) {
        this.$notify.warning('参数异常：红人必传')
        return false
      }
      if (checked) {
        this.$api.saveArtistTag(artist_id, tag_id)
      } else {
        this.$api.delArtistTag(artist_id, tag_id)
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleClose(done) {
      // 关闭弹窗回调
      this.$emit('handleSelected',this.formTag)
      done();
      // this.$confirm('确认关闭？')
      //   // eslint-disable-next-line no-unused-vars
      //   .then(_ => {
      //     done();
      //     this.$emit('handleSelected',this.formTag)
      //   })
      //   // eslint-disable-next-line no-unused-vars
      //   .catch(_ => {});
    }
  },
  created() {
    this.loadTagOptions()
  }
}

</script>

<template>
  <el-dialog title='红人标签' :visible.sync='showTagDialog'  :before-close="handleClose">
    <el-form :model='formTag' size='small' label-position='right' label-width='100px' label-suffix='：'>
      <el-form-item label='红人昵称' v-if='formTag.artist_id'>
        {{ formTag.nickname || ''}}
      </el-form-item>
      <el-form-item label='标签'>
        <el-checkbox-group v-model='formTag.tag_ids' size='mini'>
          <el-checkbox :label='tag.id' v-for='(tag) in tags' :key='tag.id'
                       @change='(t)=>handleTagChange(t,tag.id,formTag.artist_id)' border>{{ tag.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <!--      <div slot='footer' class='dialog-footer'>-->
    <!--        <el-button @click='showTagDialog = false'>取 消</el-button>-->
    <!--        <el-button type='primary' @click='showTagDialog = false'>确 定</el-button>-->
    <!--      </div>-->
  </el-dialog>
</template>

<style scoped>

</style>
